<div class="card-grid-container">
  <div class="d-flex justify-content-between align-items-center mb-3">
    @if (title()) {
      <h5 class="mb-0">{{ title() }}</h5>
    }
    @if (showCreate()) {
      <button class="btn btn-sm btn-primary" (click)="create.emit()"><i class="fa fa-plus"></i> Create</button>
    }
  </div>

  @if (!items().length) {
    <p class="text-muted" i18n>No items configured.</p>
  }

  <div class="card-grid" [style.grid-template-columns]="'repeat(auto-fill, minmax(' + minCardWidth() + 'px, 1fr))'">
    @for (item of items(); track item.id) {
      <div class="card card-grid-item" (click)="cardClick.emit(item)">
        <div class="card-header d-flex justify-content-between align-items-center">
          <strong>{{ item.header }}</strong>
          @if (showDelete()) {
            <button
              class="btn btn-sm btn-outline-danger"
              (click)="delete.emit(item); $event.stopPropagation()"
              i18n-title
              title="Delete"
            >
              <i class="fa fa-trash"></i>
            </button>
          }
        </div>
        <div class="card-body">
          @for (row of item.rows; track row.label) {
            <div class="card-grid-row" [class.highlight-row]="row.highlight">
              <span class="row-label">{{ row.label }}</span>
              <span class="row-value">{{ row.value }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
